import { useQuery } from '@tanstack/react-query';
import { getPerformers } from '../api';

export const performerKeys = {
  all: ['performers'],
};

export function usePerformers(options = {}) {
  return useQuery({
    queryKey: performerKeys.all,
    queryFn: async () => {
      const res = await getPerformers();
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
